import Vue from 'vue'
import Vuex from 'vuex'
import api from '../../static/js/https.js'
import global from '../../static/js/global.js'

Vue.use(Vuex)
const actions = {
    // 公司模板信息
    getTemplate(commit) {

        var params = {};
        api.getCompanyInfo(params).then(res => {
            global.compey = res.data;
            commit.commit('handlPidearData', res.data);
        }).catch(e => {
        })
    },
    //刷新获取用户表信息
    getUserInfo(commit, formdata) {
        api.getMemberInfo(formdata).then(res => {
            global.webData = res.data;
            commit.commit('handleUserData', res.data);
        })
    }
}
const mutations = {
    //用户信息
    handleUserData: (state, user_data) => {
        state.userData = user_data
        localStorage.setItem('user_data', user_data)
    },
    //用户token
    handleUserToken: (state, user_token) => {
        state.userToken = user_token
        localStorage.setItem('user_token', user_token)
    },
    //自定义 图片路径
    handleShowPath: (state, user_path) => {
        state.showPath = user_path
        localStorage.setItem('user_path', user_path)
    },
    //公司信息 初始化
    handlPidearData: (state, pid_data) => {
        state.pidearData = pid_data
        localStorage.setItem('pidearData', JSON.stringify(pid_data))
    }
}
const state = {
    userData: [] || localStorage.getItem('user_data'),//用户信息
    userToken: '' || localStorage.getItem('user_token'),//用户token
    showPath: '' || localStorage.getItem('user_path'),// 图片路径  自定义数据
    pidearData: [] || localStorage.getItem('pidearData'),//公司信息

}
const getters = {
    userData: (state) => state.userData,
    pidearData: (state) => state.pidearData,
}

const store = new Vuex.Store({
    actions,
    mutations,
    state,
    getters

})
export default {
    store
}



// WEBPACK FOOTER //
// ./src/store/index.js